import { ReactTFC } from "../../../../../../utils/fp/missing-ts-parts";
import { css } from "@emotion/react";
import { PaymentIcon } from "./PaymentIcon";
import React from "react";
import { labelStyles } from "./labelStyles";
import type { TranslatedValue } from "@swo/storefront";
import { T } from "../../../../../../components/T";

export const PaymentNameWithIcon: ReactTFC<{ label: string | TranslatedValue; name: string }> = props => {
  const paymentNameStyles = css`
    display: flex;
  `;

  return (
    <>
      <span css={labelStyles}>
        <T>{props.label}</T>
      </span>
      <div css={paymentNameStyles}>
        <PaymentIcon paymentName={props.name} />
      </div>
    </>
  );
};
